import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'payments',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({ type: 'cancel' })
  }
}
